// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: contents;
}

.orgs_team__members_body_item {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.orgs_team__members_body_item .member-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
}
.orgs_team__members_body_item .member-name.active {
  font-weight: 700;
}
.orgs_team__members_body_item .member-wave-link {
  flex-shrink: 0;
  line-height: 0;
  display: block;
}
.orgs_team__members_body_item .member-lead-badge {
  flex-shrink: 0;
  background-color: #676a6c;
  padding: 1px 6px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
}
.orgs_team__members_body_item .orgs_team__members_dropdown {
  flex-shrink: 0;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/org-individual-teams/roster-team-card/roster-team-card.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAGA;EACE,wBAAA;EACA,4BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAAF;AAGE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAME;EACE,cAAA;EACA,cAAA;EACA,cAAA;AAJJ;AAQE;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AANJ;AAUE;EACE,cAAA;EACA,iBAAA;AARJ","sourcesContent":[":host {\n  display: contents;\n}\n\n// ── Member row: single flat flex row, name truncates, icons never wrap ──\n.orgs_team__members_body_item {\n  display: flex !important;\n  flex-wrap: nowrap !important;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n\n  // Name — grows to fill space, truncates with ellipsis\n  .member-name {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: 600;\n    color: #676a6c;\n\n    &.active {\n      font-weight: 700;\n    }\n  }\n\n  // Profile wave link — fixed size, never shrinks or wraps\n  .member-wave-link {\n    flex-shrink: 0;\n    line-height: 0;\n    display: block;\n  }\n\n  // \"Lead\" badge\n  .member-lead-badge {\n    flex-shrink: 0;\n    background-color: #676a6c;\n    padding: 1px 6px;\n    border-radius: 5px;\n    color: #fff;\n    font-size: 12px;\n  }\n\n  // Three-dot menu — always on the right\n  .orgs_team__members_dropdown {\n    flex-shrink: 0;\n    margin-left: auto;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
